module.exports = __webpack_public_path__ + "img/banner3.0cf914d5.png";